/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_CtaInputs */

const en_mk_foot_cta = /** @type {(inputs: Mk_Foot_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try free for 14 days`)
};

const id_mk_foot_cta = /** @type {(inputs: Mk_Foot_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coba gratis 14 hari`)
};

/**
* | output |
* | --- |
* | "Try free for 14 days" |
*
* @param {Mk_Foot_CtaInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_cta = /** @type {((inputs?: Mk_Foot_CtaInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_CtaInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_cta(inputs)
	return en_mk_foot_cta(inputs)
});